export interface IPagination<T = {}> {
  Page?: number;
  PageSize?: number;
  Total?: number;
  Search?: string;
  Object?: T | null;
}

export class Pagination<T = {}> implements IPagination {
  Page: number;

  PageSize: number;

  Total: number;

  Search: string;

  Object!: T;

  constructor(page?: number, pageSize?: number, total?: number, search?: string) {
    this.Page = page || 1;
    this.PageSize = pageSize || 30;
    this.Total = total || 30;
    this.Search = search || '';
  }
}
